<template>
  <div class="content">
    <div class="header" v-if="command.hook.length">テンプレート動作</div>
    <div class="hook" v-if="command.hook.length">
      <div class="hook-list-area">
        <draggable class="hook-list"
          tag="div" :list="hook" :group="{ name:'hook' }">
          <component v-for="(h,i) in hook" :key="'hook'+i"
            :is="componentKey[h]" v-model="innerValue"
            class="hook-item" :hook="h" :info="info"
            @remove="hook.splice(i,1)" />
          </draggable>
        <div class="hook-item">
          <b-form-select v-model="additionalHook" 
            :options="hookSelect" size="sm"
            @change="additionalHook && hook.push(additionalHook) && (additionalHook = null)" />
        </div>
      </div>
    </div>
    <div class="header" v-if="callCommand">基本動作</div>
    <div class="custom" v-if="callCommand">
      <slot />
    </div>
    <div class="header" v-if="code">カスタム動作</div>
    <div class="custom" v-if="code">
      <div class="nav">
        <b-tabs>
          <b-tab title="能力" v-if="enableCommand('status')">
            <div class="cmd-nav">
              <div class="icon"
                v-b-tooltip.hover.d500 :title="componentTooltip['status.temp-add']"  
                @click="pushCode('status.temp-add')">
                <img :src="icon['status.temp-add']" />
              </div>
            </div>
          </b-tab>
          <b-tab title="表示" v-if="enableCommand('show')">
            <div class="cmd-nav">
              <div class="icon" v-b-tooltip.hover.d500 :title="componentTooltip['show.text-note']"
                @click="pushCode('show.text-note')">
                <img :src="icon['show.text-note']" />
              </div>
            </div>
          </b-tab>
          <b-tab title="攻撃" v-if="enableCommand('free/attack')">
            <div class="cmd-nav">
              <div class="icon" v-b-tooltip.hover.d500 :title="componentTooltip['free/attack.physical-attack']"
                @click="pushCode('free/attack.physical-attack')">
                <img :src="icon['free/attack.physical-attack']" />
              </div>
              <div class="icon" v-b-tooltip.hover.d500 :title="componentTooltip['free/attack.magical-attack']"
                @click="pushCode('free/attack.magical-attack')">
                <img :src="icon['free/attack.magical-attack']" />
              </div>
            </div>
          </b-tab>
          <b-tab title="攻撃" v-if="enableCommand('free/attack/buff')">
            <div class="cmd-nav">
              <div class="icon" v-b-tooltip.hover.d500 :title="componentTooltip['free/attack.buff-physical-attack']"
                @click="pushCode('free/attack.buff-physical-attack')">
                <img :src="icon['free/attack.buff-physical-attack']" />
              </div>
              <div class="icon" v-b-tooltip.hover.d500 :title="componentTooltip['free/attack.buff-magical-attack']"
                @click="pushCode('free/attack.buff-magical-attack')">
                <img :src="icon['free/attack.buff-magical-attack']" />
              </div>
            </div>
          </b-tab>
          <b-tab title="異常状態" v-if="enableCommand('free/buff')">
            <div class="cmd-nav">
              <div class="icon" v-b-tooltip.hover.d500 :title="componentTooltip['free/buff.add']"
                @click="pushCode('free/buff.add')">
                <img :src="icon['free/buff.add']" />
              </div>
              <div class="icon" v-b-tooltip.hover.d500 :title="componentTooltip['free/buff.add-power']"
                @click="pushCode('free/buff.add-power')">
                <img :src="icon['free/buff.add-power']" />
              </div>
            </div>
          </b-tab>
          <b-tab title="異常状態" v-if="enableCommand('free/buff/status')">
            <div class="cmd-nav">
              <div class="icon" v-b-tooltip.hover.d500 :title="componentTooltip['free/buff.add-status']"
                @click="pushCode('free/buff.add-status')">
                <img :src="icon['free/buff.add-status']" />
              </div>
            </div>
          </b-tab>
          <b-tab title="回復" v-if="enableCommand('free/heal')">
            <div class="cmd-nav">
              <div class="icon" v-b-tooltip.hover.d500 :title="componentTooltip['free/heal.normal-heal']"
                @click="pushCode('free/heal.normal-heal')">
                <img :src="icon['free/heal.normal-heal']" />
              </div>
            </div>
          </b-tab>
          <b-tab title="回復" v-if="enableCommand('free/heal/buff')">
            <div class="cmd-nav">
              <div class="icon" v-b-tooltip.hover.d500 :title="componentTooltip['free/heal.buff-heal']"
                @click="pushCode('free/heal.buff-heal')">
                <img :src="icon['free/heal.buff-heal']" />
              </div>
            </div>
          </b-tab>
          <b-tab title="防御" v-if="enableCommand('free/passive')">
            <div class="cmd-nav">
              <div class="icon" v-b-tooltip.hover.d500 :title="componentTooltip['free/passive.barrier']"
                @click="pushCode('free/passive.barrier')">
                <img :src="icon['free/passive.barrier']" />
              </div>
              <div class="icon" v-b-tooltip.hover.d500 :title="componentTooltip['free/passive.protect']"
                @click="pushCode('free/passive.protect')">
                <img :src="icon['free/passive.protect']" />
              </div>
            </div>
          </b-tab>
          <b-tab title="防御" v-if="enableCommand('free/passive/buff')">
            <div class="cmd-nav">
              <div class="icon" v-b-tooltip.hover.d500 :title="componentTooltip['free/passive.buff-barrier']"
                @click="pushCode('free/passive.buff-barrier')">
                <img :src="icon['free/passive.buff-barrier']" />
              </div>
              <div class="icon" v-b-tooltip.hover.d500 :title="componentTooltip['free/passive.protect']"
                @click="pushCode('free/passive.protect')">
                <img :src="icon['free/passive.protect']" />
              </div>
            </div>
          </b-tab>
        </b-tabs>
      </div>
      <div class="body">
        <div class="side">
          <draggable class="code-flow" 
            tag="ul" :list="code" :group="{ name:'code' }">
            <flow-icon v-for="(c,i) in code" :key="'code'+i"
              :class="{ active: currentCodeIndex == i }"
              @select="currentCodeIndex = $event"
              v-model="code[i]" :index="`[${i}]`" />
          </draggable>
        </div>
        <div class="edit">
          <template v-if="currentCodeIndex != null">
            <component
              :is="componentKey[currentCode['@call']]"
              v-model="currentCode"
              @removeCode="removeCode"
              :info="info"
            />
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { default as Cmd,
 iconKey, 
 hookLabel, 
 componentKey, 
 hookTooltip,
 componentTooltip
} from './mixin-cmd'
import Digest from './Digest'
import _ from 'lodash'
import draggable from 'vuedraggable'
import FlowIcon from './FlowIcon'
export { Digest }
export default {
  computed: {
    icon () { return iconKey },
    hook () { return this.innerValue.hook },
    args () { return this.innerValue.args },
    code () { return this.innerValue.code },
    callCommand () { return this.innerValue.call },
    currentCode: { 
      get () { return _.get(this.code, this.currentCodeIndex) },
      set (v) { _.set(this.code, this.currentCodeIndex, v) }
    },
    hookLabel () { return hookLabel },
    hookSelect () {
      return _.map(this.command.hook, (k)=>{ 
        return { value:k, text: hookLabel[k] } })
    },
    componentKey () { return componentKey },
    hookTooltip () { return hookTooltip },
    componentTooltip () { return componentTooltip }
  },
  props: {
    value: Object,
    command: Object,
    info: Object,
  },
  components: {
    draggable,
    FlowIcon
  },
  mixins: [ Cmd ],
  data () {
    return {
      innerValue: this.value,
      additionalHook: null,
      currentCodeIndex: null
    }
  },
  methods: {
    pushCode (k) {
      this.code.push({
        '@call': k,
        'arguments': componentKey[k].newCode()
      })
    },
    removeCode () {
      let child = _.get(this.innerValue.code, this.currentCodeIndex)
      let parent = _.get(this.innerValue.code, _.replace(this.currentCodeIndex, /\[\d+\]$/, ''))
        || this.innerValue.code
      this.$delete(parent, _.findIndex(parent, child)) //_.unsetではキーが消えない
      this.currentCodeIndex = null
    },
    enableCommand (v) {
      return _.indexOf(this.command.code, v) >= 0
    }
  },
  watch: {
    innerValue (v) {
      this.$emit('input', v)
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  position: relative;
}
.hook {
  width: 100%;
  min-height: 20%;
  border: 1px solid #CCC;

  .hook-list-area {
    display: flex;
    flex-wrap: wrap;

    .hook-list {
      display: inline-flex;
      flex-wrap: wrap;
    }
    .hook-list > .hook-item, .hook-item {
      display: inline-block;
      padding: 2px;
      margin: 2px;
      border: 1px solid #000;
    }

  }
}
.header {
  width: 100%;
  height: 1.25rem;
  background-color: #555;
  color: #FFF;
}
.custom {
  padding: 5px;
  width: 100%;
  height: calc(80% - 2.5rem);
  border: 1px solid #CCC;

  .nav {
    width: 100%;
    height: 80px;

    .cmd-nav {
      display: flex;
      flex-wrap: wrap;
    }
  }
  .body {
    width: 100%;
    height: calc(100% - 80px);
    display: flex;

    .side {
      width: 50%;
      height: 100%;
      border: 1px solid #CCC;
      overflow-y: scroll;

      .icon.active {
        border: 1px solid #000;
      }

      .code-flow {
        list-style-type: none;
        padding-left: 0;
      }
    }
    .edit {
      width: 50%;    
      height: 100%;
      border: 1px solid #CCC;
      overflow-y: scroll;
    }
  }
}
.icon {
  width: 32px;
  height: 32px;
  cursor: pointer;
  
  &:hover {
    background-color: #CCC;
  }
}
</style>
